import config from '../config';

export const PermissionLevels = {
  defaultLevel: 0,
  readOnly: 1,
  readOnlyPartnerIntegration: 2, // Can only view the dashboard
};

export const PageInfo = {
  Dashboard: {
    id: 'Dashboard',
    route: 'dashboard',
  },
  Orders: {
    id: 'Orders',
    route: 'orders',
  },
  EmailPreferences: {
    id: 'EmailPreferences',
    route: 'email-preferences',
  },
  Integration: {
    id: 'Integration',
    route: 'integration',
  },
  Coupons: {
    id: 'Coupons',
    route: 'coupons',
  },
  BasicInfo: {
    id: 'BasicInfo',
    route: 'basicinfo',
  },
  CourseDetails: {
    id: 'CourseDetails',
    route: 'coursedetails',
  },
  WhatsIncluded: {
    id: 'WhatsIncluded',
    route: 'whats-included',
  },
  Tickets: {
    id: 'Tickets',
    route: 'tickets',
  },
  AddOns: {
    id: 'AddOns',
    route: 'add-ons',
  },
  RegistrationForm: {
    id: 'RegistrationForm',
    route: 'regform',
  },
  ConfirmationEmail: {
    id: 'ConfirmationEmail',
    route: 'confirmationemail',
  },
  Faqs: {
    id: 'Faqs',
    route: 'faqs',
  },
  Webhook: {
    id: 'Webhook',
    route: 'integration/webhook',
  },
  Affiliate: {
    id: 'Affiliate',
    route: 'integration/affiliate',
  },
};

export let PagePermissions = {};

async function loadPageConfig() {
  try {
    const response = await fetch(
      `${config.BLOB_URL}/configs/RORoutePermissionConfig.json`
    );
    PagePermissions = await response.json();
  } catch (error) {
    console.error('Error loading page configuration:', error);
  }
}

// Load the configuration when the module initializes
loadPageConfig();
